import React from "react";
import DashboardPart from "./DashbordPart";
import InactiveVolunteers from "../../Images/inactive_trials.png";

const DashboardInactiveVolunteers = ({ dashboardTotalInfo, isLoading }) => {
  return (
    <DashboardPart
      DashboardHeading="Inactive Volunteers"
      DashboardValue={dashboardTotalInfo}
      Icon={InactiveVolunteers}
      style={{ background: "linear-gradient(to right, #750504, #dc3545)" }}
      isLoading={isLoading}
    />
  );
};

export default DashboardInactiveVolunteers;
